import "./scripts/dropdown";
import "./scripts/accordion";

// import "./components/Advantages/Advantages";
import "./components/Filters/Filters";
// import "./components/ProductsSlider/ProductsSlider"; swiper slider
import "./components/FiltersPanel/FiltersPanel";
import "./components/BurgerMenu/BurgerMenu";
// import "./pages/Index/components/Feed/Feed"; swiper slider
import "./pages/Product/components/ProductHead/ProductHead";
import "./pages/Product/components/ProductHead/components/ProductHeadGallery/ProductHeadGallery";
// import "./pages/Product/components/ProductHead/components/PhotoUploadZone/PhotoUploadZone"; // dropzone


import './partials/artist';
import './partials/footer-advantage-app';
import './partials/home-page-product-cat-slider';
import './partials/insta-app';
import './partials/notre-gallery-slider';
import './partials/side-cart';

import { jQuery } from './utils/jquery';

/*
Utility functions
 */

// Restricts input for the given textbox to the given inputFilter function.
function setInputFilter(textbox, inputFilter, errMsg) {
  [
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mouseup",
    "select",
    "contextmenu",
    "drop",
    "focusout",
  ].forEach((event) => {
    typeof textbox !== "undefined" &&
      textbox.addEventListener(event, function (e) {
        if (inputFilter(this.value)) {
          // Accepted value
          if (["keydown", "mousedown", "focusout"].indexOf(e.type) >= 0) {
            this.classList.remove("input-error");
            this.setCustomValidity("");
          }
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
          // eslint-disable-next-line no-prototype-builtins
        } else if (this.hasOwnProperty("oldValue")) {
          // Rejected value - restore the previous one
          this.classList.add("input-error");
          this.setCustomValidity(errMsg);
          this.reportValidity();
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          // Rejected value - nothing to restore
          this.value = "";
        }
      });
  });
}

/*
Product grid
 */

// Grid Size Range Slider Change (Product grid)
window.gridRangeSliderChange = (values) => {
  const gridSize = Number(values[0]);
  console.log("gridSize", gridSize);
  const grid = jQuery(".product-grid");
  // Eye icon vars
  const eyeEl = jQuery(".noUi-handle");
  const eyeSize = Number(values[0]);
  const eyeSizeMap = {
    0: "range-large-eye",
    1: "range-medium-eye",
    2: "range-small-eye",
  };

  const gridSizeMap = {
    0: "big",
    1: "medium",
    2: "small",
  };
  // End eye icon vars

  // Manage class on product grid
  grid.removeClass(
    Object.values(gridSizeMap).map((size) => `product-grid_size_${size}`)
  );
  grid.addClass(`product-grid_size_${gridSizeMap[gridSize]}`);
  // End manage class on product grid

  // Manage class on filter eye icon
  eyeEl.removeClass(Object.values(eyeSizeMap).map((size) => `${size}`));
  eyeEl.addClass(`${eyeSizeMap[eyeSize]}`);
  // Manage class on filter eye icon

  jQuery(document).trigger("gridRangeSliderChange", { gridSize });
};

// Sort dropdown
jQuery(document).on("click", ".js-filters-sort-option", (e) => {
  const el = jQuery(e.target);
  const allButtons = el.siblings();
  const text = el.text();
  const targetEl = jQuery(el.parent().prev());
  // const targetEl = jQuery(".js-filters-sort-value");

  jQuery('.js-dropdown-toggle').removeClass('is-active');
  allButtons.removeClass("is-active");
  el.addClass("is-active");
  targetEl.find(".js-filters-sort-value").text(text);
});

// Filters buttons
jQuery(document).on("click", ".js-filters-button", (e) => {
  const el = jQuery(e.currentTarget);
  const allButtons = el.siblings();
  allButtons.removeClass("is-active");
  el.addClass("is-active");
});

/*
Product photo upload zone
 */

// Here the Dropzone instance will be saved so you can access it
window.dropzoneInstance = null;

// Parameters for Dropzone.js
window.productPhotoUploadParameters = {
  maxFilesize: 2,
  dictDefaultMessage:
    "Envoyez-nous les photos où vous voulez simulez cette œuvre",
};

/*
Product option selector
 */
jQuery(document).on("click", ".js-accordion-button.js-product-option", (e) => {
  const el = jQuery(e.currentTarget);
  const isSold = el.find(".is-sold");

  if (isSold.length) {
    return;
  }

  const parent = el.parents(".js-product-option");
  const elHTML = el.html();
  const targetEl = parent.find(".js-product-option-active");
  const targetElHTML = targetEl.html();

  el.html(targetElHTML);
  targetEl.html(elHTML);
});

/*
Product extra option
 */
jQuery(document).on(
  "click",
  ".js-product-option-wrapper[data-optional-text]",
  (e) => {
    const el = jQuery(e.currentTarget);
    el.removeAttr("data-optional-text");
    el.removeAttr("data-optional-text-mobile");
  }
);

/*
Carte product
 */
class ProductCarte {
  amount = 0;

  sendType = "mail";

  sendValue = {
    mail: [],
    postcard: [],
    takeaway: true,
  };

  setAmount(value) {
    this.amount = value;
    jQuery('.js-variation-price-html').text(this.amount + '€');
    this.updateState();
  }

  setSendType(value) {
    this.sendType = value;
    this.updateState();
  }

  setSendValue(type, value) {
    if (Object.keys(this.sendValue).includes(type)) {
      this.sendValue[type] = value;
      this.updateState();
    }
  }

  validateSendValue(type) {
    const value = this.sendValue[type];
    if (typeof value === "boolean") {
      return value;
    }
    return (
      value.length &&
      value.every((val) => {
        if (val.required) return val.value.length > 0;
        return true;
      })
    );
  }

  updateState() {
    const button = jQuery(document).find(".js-custom-variation-add-to-cart-button");

    if (
      this.amount > 0 &&
      this.sendType &&
      this.validateSendValue(this.sendType)
    ) {
      jQuery('.js-custom-variation-product-not-found-button').hide();
      jQuery('.js-custom-variation-add-to-cart-button').show();
    } else {
      jQuery('.js-custom-variation-product-not-found-button').show();
      jQuery('.js-custom-variation-add-to-cart-button').hide();
    }
  }
}

const carteInstance = new ProductCarte();

jQuery(document).on("click", 
  ".js-carte-amount-button", (e) => {
  const el = jQuery(e.target);
  const amount = parseInt(el.text(), 10);
  el.addClass("is-active").siblings().removeClass("is-active");
  jQuery(document).trigger("empty-js-carte-amount-input");
  carteInstance.setAmount(amount);
});

jQuery('[name="custom_amount"]').on('change keyup', 
  function(e) {
  carteInstance.setAmount(parseInt(jQuery(this).val()));
});

/**
 * Trigger for do blank custom amount input
 */
jQuery(document).on("empty-js-carte-amount-input", () => {
  jQuery(".js-carte-amount-input").val("").trigger("change");
});

jQuery(document).on("change", ".js-carte-comment-radio", (e) => {
  jQuery(e.target)
    .parents(".js-carte-comment-item")
    .addClass("is-active")
    .siblings()
    .removeClass("is-active");

  carteInstance.setSendType(e.target.value);
});

jQuery(document).on("input", ".js-carte-amount-input", (e) => {
  const el = jQuery(e.target);
  const val = el.val();
  const parsedVal = parseInt(val, 10);
  const finalVal = !Number.isNaN(parsedVal) ? parsedVal : "";

  el.addClass("is-active").siblings().removeClass("is-active");
  el.val(finalVal);
  carteInstance.setAmount(finalVal);
});

jQuery(document).on("input", ".js-comment-postcard-input", () => {
  const allInputs = jQuery(document).find(".js-comment-postcard-input");
  const data = Array.from(allInputs).map((input) => ({
    name: input.name,
    value: input.value,
    required: input.required,
  }));

  carteInstance.setSendValue("postcard", data);
});

jQuery(document).on("input", ".js-comment-email-input", () => {
  const allInputs = jQuery(document).find(".js-comment-email-input");
  const data = Array.from(allInputs).map((input) => ({
    name: input.name,
    value: input.value,
    required: input.required,
  }));
  carteInstance.setSendValue("mail", data);
});

// Usersnap Bug-tracking
window.onUsersnapCXLoad = function (api) {
  api.init();
};
const script = document.createElement("script");
script.defer = 1;
script.src =
  "https://widget.usersnap.com/global/load/d95fa94d-d814-4740-b3c3-05ae38869448?onload=onUsersnapCXLoad";
document.getElementsByTagName("head")[0].appendChild(script);

// js-show-sculptures-filters
// Manage filters of grillede page
jQuery(document).on("click", ".js-show-sculptures-filters", function () {
  const thisTag = jQuery(this).prop("tagName");

  // if this is anchor tag then prevent flow
  // make sure: if this is an (A) tag then trigger click a little bit time later
  if (thisTag.toLowerCase() == "a") {
    event.preventDefault();
  }
  // Trigger dropdown menu that is hidden button
  setTimeout(() => {
    jQuery(".js-dropdown-toggle-grillede")[0].click();
  });
});

// Wishlist icon active process
jQuery(document).on("click", ".js-product-card__favourite", function () {
  const hasActiveClass = jQuery(this).hasClass("is-active");
  console.log("Has active class", jQuery(this).hasClass("is-active"));

  // perform this action when has no active class
  if (hasActiveClass === false) {
    const wishlistStep1PopBtn = jQuery(".js-popup-wishlist-step-1");
    const wishlistStep2PopBtn = jQuery(".js-popup-wishlist-step-2");
    if (wishlistStep1PopBtn.length) {
      // managw wishlist popup
      wishlistStep1PopBtn[0].click();
      wishlistStep1PopBtn.find(".is-close");
      // redirect to 2nd step

      // check for 2nd step
      if (wishlistStep2PopBtn.length) {
        setTimeout(() => {
          jQuery(wishlistStep1PopBtn.attr("href")).find(".is-close").click(); // hide old one
          wishlistStep2PopBtn[0].click();
        }, 1500);
      }
      // do toggle
      jQuery(this).toggleClass("is-active");
    }
  } else {
    jQuery(this).toggleClass("is-active");
  }
});

// Auto-resizable textarea
jQuery(document).on("input trigger-auto-resize", ".js-auto-resize", function () {
  const el = this;
  el.style.overflowY = "hidden";
  el.style.height = 0;
  el.style.height = `${el.scrollHeight}px`;
});

jQuery(".js-auto-resize").each(function () {
  jQuery(this).trigger("trigger-auto-resize");
});

// Show remaining characters for field
function displayRemainingCharactersForInput(el) {
  const containerSelector = el.data("remaining-char-container");
  const container = jQuery(containerSelector);
  container.text(parseInt(el.attr("maxlength")) - el.val().length);
}

jQuery("[data-remaining-char-container]").each(function () {
  jQuery(this).trigger("display-remaining-char-count");
});

jQuery(document).on(
  "input display-remaining-char-count",
  "[data-remaining-char-container]",
  function () {
    displayRemainingCharactersForInput(jQuery(this));
  }
);

// Header sticky
// When the user scrolls the page, execute myFunction
jQuery(window).on("load scroll", function () {

  const header = jQuery(document).find('header');
  const sT = jQuery(this).scrollTop();

  if (!header.length || jQuery("html").css("position") === "fixed") {
    return false;
  }

  if (sT > 0) {
    header.addClass("is-sticky");
  } else {
    header.removeClass("is-sticky");
  }
});

// cart page offer checkbox
jQuery(document).on("click", ".js-its-to-offer-checkbox", function () {
  const isSelecte = jQuery(this).is(":checked");
  const offerDescEl = jQuery(".its-offer-hint-desc");
  if (isSelecte) {
    offerDescEl.show();
  } else {
    offerDescEl.hide();
  }
});

// myaccount hide order details on click
jQuery(document).on("click", ".js-toggle-order-details", function () {
  jQuery(this).closest(".nx-order-history__card").toggleClass("is-active");
});

// Manage show and hide shipping details
jQuery(document).on("click", ".js-select-address", function () {
  const selectedValue = jQuery(this).val();
  const shippingAddressFromEl = jQuery(".js-shipping-details");
  if (selectedValue == "shipping") {
    shippingAddressFromEl.show();
  } else {
    shippingAddressFromEl.hide();
  }
});

// manage events on payment line select
jQuery(document).on("click", ".nx-payment-lines input[type=radio]", function () {
  const selectedValue = jQuery(this).val();
  console.log("selectedValue", selectedValue);
  const codEl = jQuery(".js-cod-el");
  if (selectedValue == "cod") {
    codEl.show();
  } else {
    codEl.hide();
  }

  const giftCardEl = jQuery(".js-gift-card-el");
  if (selectedValue == "pay_with_gift_card") {
    giftCardEl.show();
  } else {
    giftCardEl.hide();
  }
});

// change ? sytle in Comment récupérer ma carte on page: product_carte.html
jQuery(document).ready(() => {
  const titleEL = jQuery(".product-carte__option-title");
  if (!titleEL.length) {
    return;
  }
  titleEL.each(function (index, value) {
    const titleString = jQuery(this).text();
    if (titleString == "Comment récupérer ma carte ?") {
      const newTitleString = titleString.replace(
        "?",
        "<span class='font-family-initial'>?</span>"
      );
      jQuery(this).html(newTitleString);
    }
  });
  console.log("product-carte__option-title");
});

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ""}${expires}; path=/`;
}
function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

jQuery(() => {
  console.log("Coming from app js ");
});

jQuery(".single_variation_wrap").on("show_variation", (event, variation) => {
  let color1 = "#1C1107";
  let color2 = "#FFFFFF";
  let color3 = "#B36519";
  const { attributes } = variation;
  if (attributes) {
    if (attributes["attribute_pa_couleur-1"]) {
      color1 = wgatGetCircleColor(attributes["attribute_pa_couleur-1"]);
    }
    if (attributes["attribute_pa_couleur-2"]) {
      color2 = wgatGetCircleColor(attributes["attribute_pa_couleur-2"]);
    }
    if (attributes["attribute_pa_couleur-3"]) {
      color3 = wgatGetCircleColor(attributes["attribute_pa_couleur-3"]);
    }
  }

  if (color1) {
    jQuery("body").get(0).style.setProperty("--circle-color-1", color1);
  }

  if (color2) {
    jQuery("body").get(0).style.setProperty("--circle-color-2", color2);
  }

  if (color3) {
    jQuery("body").get(0).style.setProperty("--circle-color-3", color3);
  }
});

function wgatGetCircleColor(option) {
  let color = "";
  switch (option) {
    case "blanc":
      color = "#ffffff";
      break;

    case "noir":
      color = "#1c1107";
      break;

    case "marron":
      color = "#b36519";
      break;

    default:
      color = "#ffffff";
  }
  return color;
}

/**
 * @name Toggle section
 */
jQuery(document).on("click", ".js-toggle-section-trigger", function () {
  jQuery(this).closest(".js-toggle-section").toggleClass("is-active");
});
